import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";

import TxtRow from "components/Custom/TxtRow";
import UiDialog from "components/Custom/UiDialog";
import RadioBtn from "components/Custom/RadioBtn";
import Btn from "components/Custom/Btn";
import AutoComplete from "components/Custom/AutoComplete";
import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";

import { ApiMasters } from "apihandlers//masters/masters";
import { NOTIFY, DEFAULTS, FORMATS } from "common/config";
import { COLORS } from "common/colors";
import {
  ERRORS,
  LABELS,
  SUB_TITLES,
  SUCCESS,
  TITLES,
  WARNINGS,
} from "common/labels";
import { COMMON_JS } from "common/scripts";
import { DateFunctions } from "common/datefunctions";
import { ApiGeography } from "apihandlers/geography";

const ApiMastersHandler = new ApiMasters();
const ApiGeographyHandler = new ApiGeography();

const Contract = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [vehicles, setVehicles] = useState();
  const [customers, setCustomers] = useState();
  const [loadingPoints, setLoadingPoints] = useState();
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);

  const vehicleRef: any = useRef(null);
  const customerRef: any = useRef(null);
  const fromRef: any = useRef(null);
  const toRef: any = useRef(null);

  useEffect(() => {
    if (loading) {
      getVehicles();
    }
  }, [loading]);

  const getVehicles = () => {
    const args = {
      activeStatus: true,
      shortMode: true,
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
    };
    ApiMastersHandler.getVehicles(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.vehicleNumber,
          };
        });
        setVehicles(list);
        getCustomers();
      }
    });
  };

  const getCustomers = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
    };
    ApiMastersHandler.getCustomers(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.organizationName,
          };
        });
        setCustomers(list);
        getLodingPoints();
      }
    });
  };

  const getLodingPoints = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
    };
    ApiGeographyHandler.getAreas(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.areaName,
          };
        });
        setLoadingPoints(list);
        getRows();
      }
    });
  };

  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
      };
      const res: any = await ApiMastersHandler.getContracts(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatus"] = "Yes";
          } else {
            list[i]["activeStatus"] = "No";
          }
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getUserTypes:", error);
    }
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    console.log(selectedRow);
  };

  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "customerName",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.CUSTOMER_NAME,
      width: "20%",
    },
    {
      key: "vehicleNumber",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.VEHICLE_NO,
      width: "10%",
    },
    {
      key: "perKmAmt",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.PER_KM,
      width: "10%",
    },
    {
      key: "perDayFixedAmt",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.PER_DAY_FIXED_AMOUNT,
      width: "12%",
    },
    {
      key: "perMonthFixedAmt",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.PER_MONTH_FIXED_AMOUNT,
      width: "12%",
    },
    {
      key: "minKmPerMonth",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.MIN_KM_PER_MONTH,
      width: "12%",
    },
    {
      key: "fromPlace",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.FROM_PLACE,
      width: "12%",
    },
    {
      key: "toPlace",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.TO_PLACE,
      width: "12%",
    },

    {
      key: "activeStatus",
      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ACTIVE,
      width: "5%",
    },

    {
      key: "options",
      name: LABELS.OPTIONS,
      width: "5%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const manageContract = () => {
    const vehId = vehicleRef.current.selectedValue.id;
    const customerId = customerRef.current.selectedValue.id;
    const perKmAmt = (
      document.getElementById("perKmAmt") as HTMLInputElement
    ).value.trim();
    const perDayFixedAmt = (
      document.getElementById("perDayFixedAmt") as HTMLInputElement
    ).value.trim();
    const perMonthFixedAmt = (
      document.getElementById("perMonthFixedAmt") as HTMLInputElement
    ).value.trim();
    const minKmPerMonth = (
      document.getElementById("minKmPerMonth") as HTMLInputElement
    ).value.trim();

    const fromId = fromRef.current.selectedValue.id;
    const toId = toRef.current.selectedValue.id;

    const fromDt = (
      document.getElementById("fromDt") as HTMLInputElement
    ).value.trim();
    const toDt = (
      document.getElementById("toDt") as HTMLInputElement
    ).value.trim();
    const active = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const selectBtnValue = active ? active.value : "";

    // Validations
    let errors = [];
    if (!customerId) {
      errors.push({
        id: "customerId",
        msg:
          "<span class='bold'>" +
          LABELS.CUSTOMER +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      customerId,
      vehId,
      perKmAmt,
      perDayFixedAmt,
      perMonthFixedAmt,
      minKmPerMonth,
      fromId,
      toId,
      fromDt,
      toDt,
      activeStatus: selectBtnValue,
    };
    setIsSubmit(true);
    console.log("manageContract: args:", args);
    ApiMastersHandler.manageContract(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);

        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  console.log("selectedRow", selectedRow);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.CONTRACTS}</li>
        </ul>
        <h4>{TITLES.CONTRACTS}</h4>
        <p className="SubTitles">{SUB_TITLES.CONTRACTS}</p>
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            id={LABELS.CONTRACTS}
            height={window.innerHeight * 0.8}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.CONTRACTS}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + TITLES.CONTRACTS + ": " + selectedRow.assetName
              : "Add New " + TITLES.CONTRACTS
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          <div className="formGroup red">
            <label>
              {LABELS.CUSTOMER}
              {<span>{" *"}</span>}
            </label>
            <AutoComplete
              list={customers}
              childRef={customerRef}
              defaultValue={
                selectedRow.customerId
                  ? {
                      id: selectedRow.customerId,
                      label: selectedRow.customerName,
                    }
                  : null
              }
              onChange={(e, v) => {}}
              disabled={isSubmit}
              required={true}
            />
          </div>
          <div className="formGroup ">
            <label>{LABELS.SELECT_VEHICLES}</label>
            <AutoComplete
              list={vehicles}
              childRef={vehicleRef}
              defaultValue={
                selectedRow.vehicleNumber
                  ? {
                      id: selectedRow.vehId,
                      label: selectedRow.vehicleNumber,
                    }
                  : null
              }
              onChange={(e, v) => {}}
              disabled={isSubmit}
            />
          </div>

          <div className="formGroup ">
            <TxtRow
              id={"perKmAmt"}
              type={"number"}
              label={LABELS.PER_KM}
              defaultValue={selectedRow.perKmAmt}
              disabled={isSubmit}
              required={false}
            />
          </div>
          <div className="formGroup ">
            <TxtRow
              id={"perDayFixedAmt"}
              type={"number"}
              label={LABELS.PER_DAY_FIXED_AMOUNT}
              defaultValue={selectedRow.perDayFixedAmt}
              disabled={isSubmit}
              required={false}
            />
          </div>
          <div className="formGroup ">
            <TxtRow
              id={"perMonthFixedAmt"}
              type={"number"}
              label={LABELS.PER_MONTH_FIXED_AMOUNT}
              defaultValue={selectedRow.perMonthFixedAmt}
              disabled={isSubmit}
              required={false}
            />
          </div>
          <div className="formGroup ">
            <TxtRow
              id={"minKmPerMonth"}
              type={"number"}
              label={LABELS.MIN_KM_PER_MONTH}
              defaultValue={selectedRow.minKmPerMonth}
              disabled={isSubmit}
              required={false}
            />
          </div>

          <div className="formGroup ">
            <label>{LABELS.FROM_AREA}</label>
            <AutoComplete
              list={loadingPoints}
              childRef={fromRef}
              defaultValue={
                selectedRow.fromPlace
                  ? {
                      id: selectedRow.fromId,
                      label: selectedRow.fromPlace,
                    }
                  : null
              }
              onChange={(e, v) => {}}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup ">
            <label>{LABELS.TO_AREA}</label>
            <AutoComplete
              list={loadingPoints}
              childRef={toRef}
              defaultValue={
                selectedRow.toPlace
                  ? {
                      id: selectedRow.toId,
                      label: selectedRow.toPlace,
                    }
                  : null
              }
              onChange={(e, v) => {}}
              disabled={isSubmit}
            />
          </div>
          <div className="flexRowJustify">
            <div className="formGroup width45">
              <TxtRow
                id={"fromDt"}
                type={"date"}
                label={LABELS.FROM_DATE}
                defaultValue={
                  selectedRow.fromDt
                    ? DateFunctions.getFormatedDate(
                        selectedRow.fromDt,
                        FORMATS.SQL_DATE,
                        FORMATS.SQL_DATE_ONLY
                      )
                    : DateFunctions.getDate(
                        "today",
                        "from",
                        FORMATS.SQL_DATE_ONLY
                      )
                }
                disabled={isSubmit}
                required={false}
              />
            </div>
            <div className="formGroup width45">
              <TxtRow
                id={"toDt"}
                type={"date"}
                label={LABELS.TO_DATE}
                defaultValue={
                  selectedRow.toDt
                    ? DateFunctions.getFormatedDate(
                        selectedRow.toDt,
                        FORMATS.SQL_DATE,
                        FORMATS.SQL_DATE_ONLY
                      )
                    : DateFunctions.getDate(
                        "today",
                        "from",
                        FORMATS.SQL_DATE_ONLY
                      )
                }
                disabled={isSubmit}
                required={false}
              />
            </div>
          </div>
          <div className="formGroup">
            <label>{LABELS.ACTIVE + " " + LABELS.STATUS}</label>
            <RadioBtn
              list={[
                {
                  id: "activeYes",
                  value: "true",
                  label: LABELS.ACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === true
                    : true,
                  disabled: false,
                },
                {
                  id: "activeNo",
                  value: "false",
                  label: LABELS.INACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === false
                    : false,
                  disabled: false,
                },
              ]}
              row={true}
              name={"activeStatus"}
              disabled={isSubmit}
            />
          </div>
          {/* mandatoryResults */}
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          <div className="formGroup submitBtnWrapper">
            <div className="flexbtnjustify">
              <Btn
                text={LABELS.CANCEL}
                // loading={isSubmit}
                bgColor={COLORS.RELOAD_EXPORT}
                color={COLORS.RELOAD_EXPORT_TEXT}
                onClick={() => {
                  setManageDialog(false);
                  setMandatoryResults([]);
                }}
              />
              <Btn
                text={LABELS.SAVE}
                loading={isSubmit}
                onClick={manageContract}
                bgColor={COLORS.SAVE_GREEN}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(Contract);
